import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticateService } from '../share/services/authenticate.service';
import { finalize } from 'rxjs/operators';
import { NavigationService } from '../share/services/navigation.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  token: string;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private formBuilder: FormBuilder,
    private authenticateService: AuthenticateService,
    private navigationService: NavigationService,
    private activatedRoute: ActivatedRoute) {

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  get f() { return this.form.controls; }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    this.submitted = true;
    let password = this.f.password.value;
    let confirmPassword = this.f.confirmPassword.value;
    this.authenticateService.resetPassaword(this.token, password, confirmPassword)
      .pipe(finalize(() => {
        this.submitted = false;
        //this.changeDetectorRef.detectChanges();
      }))
      .subscribe(
        (res) => {
          console.log("res ", res);
          this.navigationService.goToLogin();
        },
        (err) => {
          console.log("ERR ", err);
        }
      )
  }

}
